const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/payments/api-factory');
const serviceFactory = require('../resources/payments/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/transactions/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  return app => app
    .match((
      `${p}payments.initializeTx[{keys:txType}][{keys:guidStr}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.initializeTx(req.params.txType, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
      
    .match((
        `${p}payments.generateTxChallenge[{keys:fieldObj}][{keys:txType}][{keys:guidStr}]`
      ), requests =>
        Promise.all(requests.map(({ req, res }) =>
          service.generateTxChallenge(req.params.fieldObj,req.params.txType, req.params.metaData)
            .then(xs => res.value(xs))
            .catch(res.error)
        )))
  
    .match((
      `${p}payments.verifyChallengeResponse[{keys:details}]`
    ), requests =>
      Promise.all(requests.map(({ req, res }) =>
        service.verifyChallengeResponse(req.params.details, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
      
}

module.exports = addRoutes;
